<template>
  <div>
    <PBannerBase height="auto" :inative="false" :isDefault="false" warning>
      <template #title>Atenção</template>
      Essa integração possui um limite de requisições por conta de uma
      característica do parceiro. Para uma boa experiência, por favor, faça
      chamadas de serviço de um período pequeno e em uma frequência baixa para
      que o parceiro não faça bloqueios na requisição
    </PBannerBase>
  </div>
</template>

<script setup lang="ts">
import { PBannerBase } from "@f360-dev/f360-prisma";
</script>
